import { MDBCard } from "mdb-react-ui-kit";
import { FC, useMemo, useState } from "react";
import { useRouter } from "next/router";
import Image from "next/image";
import { useIsClient } from "@/utils/hooks/useIsClient";
import { getDestinationsSize } from "@/utils/common";
import { useStore } from "@/store/index";
import { useIsSM } from "@/utils/hooks/useWindowSizes";
import styles from "../../../../styles/home/Home.CardTour.module.scss";
import HeadOverlay from "./HeadOverlay";
import CardBody from "./CardBody";
import CardFooter from "./CardFooter";
import { slugify } from "../../../../utils/searchUtils";
import { ToursEntity } from "../../../../models/home";

const CardTour: FC<{
    content: ToursEntity;
    isSmall?: boolean;
    className?: string;
    classNameBody?: string;
    height?: string;
    fromSection?: string;
}> = ({
    content,
    isSmall,
    className = "",
    classNameBody = "",
    height = "58%",
    fromSection,
}) => {
    const [error, setError] = useState(false);
    const router = useRouter();
    const isClient = useIsClient();

    /* eslint-disable radix */
    const iOSVersion = useMemo(() => {
        if (!isClient) return null;
        const ua = navigator.userAgent;
        if (ua && /(iPhone|iPod|iPad)/i.test(ua)) {
            const version = ua
                .match(/OS [\d_]+/i)?.[0]
                .slice(3)
                .split("_")
                .find(n => parseInt(n));
            return version ? Number(version) : null;
        }
        return null;
    }, [isClient]);
    /* eslint-enable */

    const [hover, setHover] = useState<boolean>(false);
    // eslint-disable-next-line no-underscore-dangle
    const userId = useStore(state => state.userState.userDetail._id);
    const dispatchRequestAQuote = useStore(
        state => state.dispatchRequestAQuote
    );
    const isSM = useIsSM();

    const handleClickText = () => {
        router.push({
            pathname: "/detail/[slug]",
            query: {
                slug: slugify(content.title ?? "Title"),
            },
        });
    };

    const handleClick = () => {
        if (isSM) {
            setHover(!hover);
        }
        if (content.requestAQuote) {
            dispatchRequestAQuote({
                type: "SET_REQUEST_A_QUOTE",
                payload: {
                    isOpen: true,
                    // eslint-disable-next-line no-underscore-dangle
                    idTour: content._id,
                    title: content.title ?? "",
                    activities: content.requestAQuoteActivities,
                },
            });
        } else if (userId) {
            if (hover) {
                handleClickText();
            }
        } else {
            handleClickText();
        }
    };

    /* eslint-disable no-underscore-dangle */

    return (
        <MDBCard
            className={`${
                isSmall ? styles.cardBodySmall : styles.cardBody
            } ${className}`}
            style={{
                justifyContent: "space-between",
                position: "relative",
            }}
            // onClick={handleClick}
        >
            <div
                className={`${styles.ripple} bg-image hover-overlay`}
                style={{
                    height,
                    maxHeight: height,
                    minHeight: height,
                }}
                onMouseEnter={() => {
                    setHover(true);
                }}
                onMouseLeave={() => {
                    setHover(false);
                }}
            >
                <div
                    className={`${
                        iOSVersion && iOSVersion <= 14
                            ? styles.imageContainer
                            : "h-100"
                    }`}
                    onClick={handleClick}
                >
                    <Image
                        className="object-cover h-100"
                        src={
                            error
                                ? "/images/tours/across-italy-reduced.jpg"
                                : content.image
                        }
                        alt="avatar-image"
                        fill
                        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                        quality={75}
                        onError={() => {
                            setError(true);
                        }}
                    />
                </div>
                {hover && (
                    <HeadOverlay
                        id={content._id}
                        rating={content.rating}
                        title={content.title ?? "Title"}
                        isSmall={isSmall!}
                        onClick={handleClick}
                        isRequestAQuote={content.requestAQuote}
                    />
                )}
            </div>
            {/* <div
                style={{
                    flex: 1,
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                }}
                onClick={handleClickText}
            >
                <CardBody
                    title={content.title ?? "Title"}
                    duration={content.duration}
                    nightDuration={content.nightDuration}
                    destinationCount={getDestinationsSize(
                        content?.destinations
                    )}
                    isSmall={isSmall!}
                    rating={content.rating}
                    reviewsCount={content.reviews}
                    className={classNameBody}
                />
                <div>
                    <hr className="m-0 my-2 mx-3" />
                    <CardFooter
                        className="px-3 d-flex"
                        price={
                            !content.startingPrice
                                ? +content.price
                                : +content.startingPrice
                        }
                        // rating={content.rating}
                        // reviewsCount={content.reviews}
                        isSmall={isSmall!}
                        fromSection={fromSection}
                    />
                </div>
            </div> */}
            <CardBody
                title={content.title ?? "Title"}
                duration={content.duration}
                nightDuration={content.nightDuration}
                destinationCount={getDestinationsSize(content?.destinations)}
                isSmall={isSmall!}
                rating={content.rating}
                reviewsCount={content.reviews}
                className={classNameBody}
                handleClick={handleClickText}
            />
            <div
                style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <hr className="m-0 mx-3" />
                <CardFooter
                    className="px-3 d-flex h-100"
                    price={
                        !content.startingPrice
                            ? +content.price
                            : +content.startingPrice
                    }
                    // rating={content.rating}
                    // reviewsCount={content.reviews}
                    isSmall={isSmall!}
                    fromSection={fromSection}
                />
            </div>
        </MDBCard>
    );
    /* eslint-enable no-underscore-dangle */
};

CardTour.defaultProps = {
    isSmall: false,
    className: "",
};

export default CardTour;
